module.exports = __webpack_public_path__ + "static/media/privacy-policy.ff481434.png";